import { createStore } from 'vuex'

var URL = 'https://server-web.konaweselatankab.go.id/'  // SERVER WEB DINAS UNTUK GET SLIDER DARI WEBSITE BRIDA DIMASUKKAN KE APLIKASI ERIDA

var API = 'https://server-erida.konaweselatankab.go.id/' // SERVER ERIDA
// var API = 'http://localhost:5050/'

export default createStore({
  state: {
    URL_SLIDE                                 : URL + 'api/v1/publish_balitbang_slider/',
    FILE_LOAD                                 : URL + 'uploads/',
    URL                                       : API,
    URL_BERANDA                               : API + 'api/v1/publish_beranda/',
    URL_DOKUMEN                               : API + 'api/v1/web_dokumen/',
    URL_ARTIKEL                               : API + 'api/v1/publish_artikel/',
    URL_PUBLIKASI                             : API + 'api/v1/publish_publikasi/',
    URL_INOTEK                                : API + 'api/v1/publish_sida/',
    URL_PANDUAN                               : API + 'api/v1/publish_panduan/',
    URL_TENTANG                               : API + 'api/v1/publish_profil/',
    URL_BERITA                                : API + 'api/v1/web_publish_berita/',
    URL_KEGIATAN                              : API + 'api/v1/web_publish_kegiatan/',
    URL_TEMA                                  : API + 'api/v1/web_publish_tema/',
    URL_IKM                                   : API + 'api/v1/web_publish_ikm/',
    URL_TIM                                   : API + 'api/v1/web_publish_tim/',
    URL_MANIS                                 : API + 'api/v1/publish_manis/',
    FILE_PATH                                 : API + 'uploads/',

  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
